import React, {useState} from 'react'
import copyIcon from '../../assets/svg/copy.svg'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import Alert from './Alert'

type Props = {
    text: any,
    displayedText?: any,
    textArea?: any,
    textStyle?: string,
    style?: string,
    mssgStyle?: string,
    imgStyle?: string
}

const CopyText: React.FC<Props> = ({text, displayedText, textArea, textStyle, style, mssgStyle, imgStyle}) => {
    const [showMssg, setShowMssg] = useState(false)

    const conetent = <span className={`${mssgStyle} font-semibold text-sm leading-5 text-Success absolute`}>Copied!</span>

    const handleCopy = () => {
      
        Alert('success','Copied!')
        
        setShowMssg(true)
        setTimeout(() => {
            setShowMssg(false)
        }, 1500);
    }

    return (
        <div className={`flex justify-between gap-3 items-center w-fit relative ${style} ${textStyle}`}>
            <span className={`text-sm ${textArea}`}>
                {displayedText ? displayedText : text}
            </span>
            <span className='flex-shrink-0 cursor-pointer'>
                <CopyToClipboard text={text} onCopy={handleCopy}>
                    <img src={copyIcon} alt='copyIcon' className={`${imgStyle} cursor-pointer`} onClick={(e) => e.stopPropagation()}/>
                </CopyToClipboard>
            </span>
        </div>
    )
}

export default CopyText;